export let PostChatSurveyMode;
(function (PostChatSurveyMode) {
  PostChatSurveyMode["Embed"] = "192350000";
  PostChatSurveyMode["Link"] = "192350001";
})(PostChatSurveyMode || (PostChatSurveyMode = {}));